import React, { useState } from 'react';
import { Spin } from 'antd';
import CareerSurvey from './CareerSurvey';
import allQuestionsData from './all_questions.json';

const CareerQuizComplete = () => {
    const [accessCode, setAccessCode] = useState('');
    const [isCodeValid, setIsCodeValid] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation: Must be exactly 6 digits
        const isValid = /^\d{6}$/.test(accessCode);

        if (isValid) {
            setError('');
            setIsCodeValid(true);
        } else {
            setError('Please enter a valid 6-digit code.');
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // Only allow numbers and max length of 6
        const numbersOnly = value.replace(/[^0-9]/g, '').slice(0, 6);
        setAccessCode(numbersOnly);
        if (error) setError('');
    };

    if (isCodeValid) {
        return <CareerSurvey quizData={allQuestionsData} />;
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 animate-fadeIn">
            <div className="text-center max-w-lg w-full bg-white/50 backdrop-blur-sm p-10 rounded-2xl shadow-sm border border-white/40">
                <h1 className="large-gradient-heading text-[2.5rem] md:text-[3.5rem] mb-4 brand-font font-light tracking-wide">
                    Crystal Report
                </h1>

                <h2 className="text-xl text-[#92278F] font-bold mb-4 brand-font">
                    Full Assessment
                </h2>

                <div className="h-[2px] w-24 bg-gradient-to-r from-[var(--color-brand)] to-[var(--color-highlight)] mx-auto mb-8 opacity-60"></div>

                <p className="brand-text text-lg text-[var(--color-subtext)] mb-8 font-light leading-relaxed">
                    Please enter your 6-digit access code to begin the complete behavioral evaluation.
                </p>

                <form onSubmit={handleSubmit} className="flex flex-col items-center gap-6 w-full">
                    <div className="w-full max-w-xs relative">
                        <input
                            type="text"
                            value={accessCode}
                            onChange={handleChange}
                            placeholder="Enter 6-digit code"
                            className="w-full text-center text-2xl tracking-widest p-4 rounded-xl border-2 border-transparent focus:border-[#92278F] focus:ring-2 focus:ring-[#92278F]/20 outline-none transition-all bg-white shadow-inner font-mono"
                        />
                        {error && (
                            <p className="text-red-500 text-sm mt-2 absolute -bottom-6 w-full text-center font-bold">
                                {error}
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={accessCode.length !== 6}
                        className={`mt-4 rotating-border-button group scale-100 transition-transform duration-300 ${accessCode.length !== 6 ? 'opacity-50 cursor-not-allowed grayscale' : 'hover:scale-105 active:scale-95'}`}
                    >
                        <span className="gradient-small text-lg md:text-xl px-10 py-2 block tracking-wider uppercase font-bold">
                            Unlock
                        </span>
                    </button>
                </form>
            </div>

            <p className="fixed bottom-8 text-[var(--color-subtext)] text-xs brand-text opacity-50 tracking-widest uppercase">
                Designed for Yancha
            </p>
        </div>
    );
};

export default CareerQuizComplete;
